import { parseData } from 'libs/api';
import authFetch from 'libs/auth-fetch';

import { normalizeApiSecrets } from './models';

export const getApiApplicationSecrets = async (applicationId: string) => {
  const response = await authFetch(
    `/apim/applications/${applicationId}/secrets`,
  );

  const data = await parseData(response, 200);

  return normalizeApiSecrets(data);
};
